/**
 * 在图表上展示参考线
 */
import { useMemo } from 'react';
import { formatNumberByComma } from "@/pages/datalab/utils/utils";

function toPrecisePercent(decimalStr, maxFractionDigits = 20) {
  const decimal = parseFloat(decimalStr);
  // 使用toLocaleString自动处理四舍五入
  return decimal.toLocaleString('en-US', {
    style: 'percent',
    // minimumFractionDigits: 0,
    maximumFractionDigits: maxFractionDigits
  }).replace(/\s/g, ''); // 移除可能出现的空格（某些地区格式）
}

export const ReferenceLineSeriesName = 'Datalab Reference Line';

const useReferenceLine = (params: any) => {
  const { option, referenceLines, isPercent } = params;
  return useMemo(() => {
    
    try {
      if (!referenceLines?.length) return option;
      
      // 一期 肯定都是 fixed, 显示用户设置的固定数值, 从配置项中取值
      // 二期(未开始) 根据后端返回的 min, avg, 也相当于是固定数值, 统一从接口中取值
      //
      const series = [...option.series];
      
      referenceLines.forEach((config: any, index: number) => {
        const { style, value, label } = config;
        if (isNaN(parseFloat(value?.number))) {
          return;
        }
        
        let formatter: string = label;
        if (!formatter) { // 用户没有设置label, 展示 value.number
          // 如果Y轴是百分比, 要value.number * 100 后拼接%
          if (isPercent) {
            formatter = toPrecisePercent(value.number);
          } else {
            // 普通数据, 使用千分隔符
            formatter = formatNumberByComma(value.number);
          }
        }
        
        
        const yAxis = isPercent ? parseFloat(value.number) * 100: parseFloat(value.number);
        /**
         * 为每一个参考线 都创建一条折线数据, 用于显示参考线
         * 折线在Y轴的数值, 设置为参考线的数值, 这样 图表可以自动计算Y轴的最大最小值, 参考线可以一直显示
         * 同时可以兼容 用户开启Y轴自适应场景
         * 同时, 置灰图例后, 导致Y轴刻度变化, 依然可以显示参考线
         */
        
        series.push({
          name: ReferenceLineSeriesName,
          data: [yAxis],
          type: 'line',
          showSymbol: false, // 不显示标记点
          legendHoverLink: false, // 鼠标悬停时不显示图例交互效果
          silent: true, // 不响应和触发鼠标事件
          markLine: {
            data: [{
              name: index,
              yAxis,
              label: {
                show: true,
                position: 'insideStartTop',
                distance: [0, 4],
                color: style.color,
                formatter,
              },
              lineStyle: {
                color: style.color,
                type: style.type,
              },
            }],
            silent: true,
            symbol: 'none'
          }
        });
      });
      
      return {...option, series};
      
    } catch (e) {
      console.error("设置参考线错误: ", e);
      return option;
    }
  }, [option]);

};



export default useReferenceLine;